// components/CategorySelect.tsx
import React from "react";
import CustomDropdownSelect from "src/business-types/grocery/components/DropdownSelect";
import { Category } from "src/shared/services/interfacev2";

interface CategorySelectProps {
  categories: Category[];
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  showError?: boolean;
  helperText?: string;
  label?: string;
  disabled?: boolean;
}

const CategorySelect: React.FC<CategorySelectProps> = ({
  categories,
  value,
  onChange,
  required = false,
  showError = false,
  helperText = "Category type is required",
  label = "Category type",
  disabled = false,
}) => {
  const isError = showError && required && !value;

  // 🔁 Convert Category[] → Dropdown options
  const options = categories.map((c) => ({
    _id: c._id.$oid,
    CategoryName: c.name,
  }));

  return (
    <div className="w-full">
      <CustomDropdownSelect
        name="categoryId"
        title={label}
        value={value}
        options={options}
        onChange={onChange}
        mandatory={required}
        titleofSelect={`Select ${label.toLowerCase()}`}
        disabled={disabled}
      />

      {/* Error text */}
      {isError && <p className="text-xs text-red-600 mt-1">{helperText}</p>}
    </div>
  );
};

export default CategorySelect;
